import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import colors from "./colors";
function withOffset(options) {
    return typeof options.offset !== "undefined";
}
export function focusOutline(options) {
    var borderColor = options.borderColor, boxShadow = options.boxShadow, _borderWidth = options.borderWidth, borderWidth = _borderWidth === void 0 ? "1px" : _borderWidth, _borderStyle = options.borderStyle, borderStyle = _borderStyle === void 0 ? "solid" : _borderStyle;
    var outline = {
        borderColor: borderColor,
        borderWidth: borderWidth,
        borderStyle: borderStyle,
        boxShadow: boxShadow
    };
    if (withOffset(options)) {
        var _borderRadius = options.borderRadius, borderRadius = _borderRadius === void 0 ? 0 : _borderRadius, offset = options.offset;
        return {
            '[tabindex="-1"]': {
                position: "relative",
                ":before": _object_spread({
                    content: "''",
                    position: "absolute",
                    borderRadius: borderRadius,
                    top: -offset.y,
                    right: -offset.x,
                    bottom: -offset.y,
                    left: -offset.x
                }, outline)
            }
        };
    }
    return outline;
}
export var defaultOptions = {
    borderColor: colors.primary80,
    boxShadow: "0 0 0 4 ".concat(colors.primary40),
    borderWidth: "1px",
    borderRadius: 4
};
export var defaultOffset = {
    x: 5,
    y: 3
};
/**
 * Default focus outline styles
 */ export var outlines = {
    default: focusOutline(_object_spread({}, defaultOptions)),
    withOffset: focusOutline(_object_spread_props(_object_spread({}, defaultOptions), {
        offset: _object_spread({}, defaultOffset)
    })),
    defaultOutline: {
        outlineWidth: 4,
        outlineStyle: "solid",
        outlineColor: colors.primary40,
        outlineOffset: 3
    }
};
export default {
    focusOutline: focusOutline,
    defaultOptions: defaultOptions,
    defaultOffset: defaultOffset,
    outlines: outlines
};
